import React, { useState } from "react";
import { Row, Col, FormGroup, Label, Input, Button } from "reactstrap";
import { Filter, X } from "react-feather";

/**
 * DeviceTypesFilter - Filter component for device types view
 */
const DeviceTypesFilter = ({ filters, onApplyFilters, onClearFilters }) => {
  const [localFilters, setLocalFilters] = useState(filters);

  const handleChange = (field, value) => {
    setLocalFilters((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleApply = () => {
    onApplyFilters(localFilters);
  };

  const handleClear = () => {
    const defaultFilters = {
      name: "",
    };
    setLocalFilters(defaultFilters);
    onClearFilters();
  };

  return (
    <div className="device-types-filter mb-3 p-3 border rounded">
      <h6 className="mb-3">
        <Filter size={16} className="me-2" />
        Filters
      </h6>
      <Row>
        <Col md="6">
          <FormGroup>
            <Label for="filterName">Device Type Name</Label>
            <Input
              id="filterName"
              type="text"
              placeholder="Search by name..."
              value={localFilters.name || ""}
              onChange={(e) => handleChange("name", e.target.value)}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col className="d-flex align-items-center gap-2">
          <Button
            color="primary"
            onClick={handleApply}
            title="Apply Filters"
          >
            <Filter size={14} className="me-1" />
            Apply
          </Button>
          <Button
            color="secondary"
            size="sm"
            outline
            onClick={handleClear}
          >
            <X size={14} className="me-1" />
            Clear Filters
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default DeviceTypesFilter;
